import React from 'react';
import { Carousel } from 'react-bootstrap';

import Row from '../../components/row';
import P1 from './images/home1.jpg';
import P2 from './images/home2.jpg';
import P3 from './images/home3.jpg';
import P4 from './images/home4.jpg';

const Gallery = () => {
  const style = { maxHeight: '520px' };
  return (
    <Row>
      <div className="col-lg-12 text-center">
        <div className="mt30">
          <h1 >Nuestra Posada</h1>
          <hr className="tagline-divider" />
        </div>
        <Carousel className="mt30">
          <Carousel.Item>
            <img style={style} className="img-responsive img-full" role="presentation" src={P1}/>
          </Carousel.Item>
          <Carousel.Item>
            <img style={style} className="img-responsive img-full" role="presentation" src={P4}/>
          </Carousel.Item>
          <Carousel.Item>
            <img style={style} className="img-responsive img-full" role="presentation" src={P3}/>
          </Carousel.Item>
          <Carousel.Item>
            <img style={style} className="img-responsive img-full" role="presentation" src={P2}/>
          </Carousel.Item>
        </Carousel>
      </div>
    </Row>
  );
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/home/carousel-gallery/index.js